import { Box, Typography, useTheme } from "@mui/material";
import Icon from "../../../../Icon/Icon";

// Subtitulo de un grupo de campos dentro del alta / ficha de un involucrado.
// Se ve subordinado al titulo de la seccion (ethicsBlue) para marcar jerarquia.
export const InvolvedSectionTitle = ({ icon, text, sx = {} }) => {
  const theme = useTheme();

  return (
    <Box display="flex" alignItems="center" gap={1} width="100%" sx={sx}>
      {icon && (
        // El prop color del Icon solo pinta el svg raiz, por eso se fuerza el
        // fill sobre los paths internos.
        <Box
          display="flex"
          sx={{ "& svg, & svg *": { fill: theme.palette.blueGray.main } }}
        >
          <Icon name={icon} size={18} />
        </Box>
      )}
      <Typography
        fontSize={13}
        fontWeight={700}
        letterSpacing={0.5}
        textTransform="uppercase"
        color={theme.palette.blueGray.main}
        whiteSpace="nowrap"
      >
        {text}
      </Typography>
      <Box flexGrow={1} height="1px" bgcolor={theme.palette.blueGray200.main} />
    </Box>
  );
};
